import { useKeycloakUser } from '@hooks/useKeycloakUser';

export const useUserEmail = (): string | null => {
  const user = useKeycloakUser();
  return user?.email ?? null;
};
